// @ts-nocheck
import * as React from "react";

// TEST
import { draws } from "../../config/constants";

// Components
import Loader from "../Loader";
import Banner from "../Banner";
import CardDraw, { DrawPreview } from "../CardDraw";
import ModalInfo from "../modalInfo";

const THEMEURL = window.drupalSettings
  ? window.drupalSettings.path.themeUrl
  : "themes/custom/mx_aguas_firmes_theme";
enum TypeCardDraw {
  default,
  large,
}

export const Gallery = ({ setLoading, loading, data }: ComponentArticles) => {
  const [currentDraw, setCurrentDraw] = React.useState<any>(null);
  const [filteredDraws, setFilteredDraws] = React.useState<any>([]);
  const [textSearch, setTextSearch] = React.useState<any>(undefined);
  const [locationOption, setLocationOption] = React.useState<any>(undefined);
  const [categoryOption, setCategoryOption] = React.useState<any>(undefined);
  const [responseData, setResponseData] = React.useState<any>([]);
  const [responsePages, setResponsePages] = React.useState<any>([]);
  const [currentPage, setCurrentPage] = React.useState<any>([]);
  const [isClickDraw, setIsClickDraw] = React.useState<any>(false);
  const topRefScrool = React.useRef<any>(null)
  
  const maxDraws = () => {
    const cardNumber = {
      '1': 15,
      '2': 16,
      '3': 15,
      '4': 16,
      '5': 15,
      '6': 18,
    }
    const columns = parseInt(window.innerWidth / 300)
    return cardNumber[`${columns}`]
  }
  
  React.useEffect(() => {
    window.onload = function () {
      setLoading(false);
    };
  }, []);
  
  React.useEffect(() => {
    dataDraws(1, maxDraws());
  }, []);

  const dataDraws = (page = 1, limit = 18, filter = null, place = null, category = null, reestructurepages = false) => {

    let API_URL = `/info/gallery/draws?page=${page}&limit=${limit}`;
    if (filter) {
      API_URL += `&filter=${filter}`;
    }
    if (place) {
      API_URL += `&place=${place}`;
    }
    if (category) {
      API_URL += `&category=${category}`;
    }
    fetch(API_URL, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((response) => {
        setCurrentPage(page);
        setResponseData(response.drawings);
        if (responsePages.length == 0 || reestructurepages) {
          const countDraws = document.querySelector('#countDraws');
          if (countDraws) {
            countDraws.innerHTML = response.count;
          }
          setResponsePages(response.pages);
        }
        else {
          topRefScrool.current.scrollIntoView();
        }
      })
      .catch(function (error) { });
  };

  React.useEffect(() => {
    const btnPAge = document.querySelectorAll('.af-gallery__pagebtn')
    if (btnPAge) {
      btnPAge.forEach(element => {
        element.classList.remove('btnGalleryActiveAf');
      })
    }
    const activeBtn = document.querySelector(`.af-gallery__pagebtn[page="${currentPage}"]`);
    if (activeBtn) {
      activeBtn.classList.add('btnGalleryActiveAf');
    }
  }, [currentPage]);

  React.useEffect(() => {
  }, [responseData]);

  React.useEffect(() => {
    //filterDraws();
    if (textSearch != undefined || locationOption != undefined || categoryOption != undefined ) {
      dataDraws(1, maxDraws(), textSearch, locationOption, categoryOption, true);
    }
  }, [textSearch, locationOption, categoryOption]);

  React.useEffect(() => {
    if (currentDraw) {
      setTimeout(() => {
        const referencePoint = document.querySelector(".af-draw-preview__draw");
        const cardBox = document.querySelector(".af-draw-preview");
        if (cardBox && referencePoint) {
          setIsClickDraw(false);
          referencePoint.scrollIntoView({ block: "center", behavior: "smooth" });
        }
      }, 100)
    }
  }, [currentDraw, isClickDraw]);

  const handleClickDraw = (data) => {
    setIsClickDraw(true);
    setCurrentDraw(data);
  };

  const filterDraws = () => {
    let nwDrawList = responseData
      .filter((draw) =>
        textSearch
          ? draw.draw_title.toLowerCase().includes(textSearch.toLowerCase())
          : draw
      )
      .filter((draw) =>
        locationOption
          ? draw.place.toLowerCase() == locationOption.toLowerCase()
          : draw
      )
      .filter((draw) =>
        categoryOption
          ? draw.category.toLowerCase() == categoryOption.toLowerCase()
          : draw
      );
    setFilteredDraws(nwDrawList);
  };

  const updateFilters = ({ target }: any) => {
    switch (target.id) {
      case "textFilter":
        setTextSearch(target.value);
        break;

      case "selectFilterCategory":
        setCategoryOption(target.value);
        break;

      case "selectFilterCity":
        setLocationOption(target.value);
        break;
    }
  };

  return (
    <main className="gallery">
      <ModalInfo
        title={"¡Gracias por votar!"}
        subtitle={"Tu voto fue registrado"}
        desc={"En los próximos días anunciaremos el dibujo ganador"}
        vote={localStorage.getItem("userVoted")}
      />
      <Banner
        backImage={{
          desk: `/${THEMEURL}/sources/dist/assets/images/gallery/bg-gallery.jpg`,
          mobile: `/${THEMEURL}/sources/dist/assets/gallery/bg-gallery.jpg`,
        }}
        textBanner={!loading && data.field_title ? data.field_title : ""}
        textDescription={data.field_desc}
        newBanner={1}
      />
      <div className="gallery__content" ref={topRefScrool}>
        <div className="gallery-container">
          {/* <div className="af-gallery-notice" data-aos="fade-up">
            <section className="af-gallery-notice__left">
              <h2 className="af-gallery-notice__title">
                {data.field_subtitle}
              </h2>
              <p className="af-gallery-notice__desc">{data.field_subdesc}</p>
            </section>
            <section className="af-gallery-notice__right">
              <a href="/participar" className="af-gallery-notice__btn">
                {data.field_txtbtn1}
              </a>
            </section>
          </div> */}
          {currentDraw == null ? (
            <React.Fragment>
              <section className="af-gallery-filter">
                <input
                  id="textFilter"
                  data-aos="fade-in"
                  className="af-gallery-filter__text"
                  type="text"
                  placeholder="Buscar por nombre de obra..."
                  value={textSearch}
                  onChange={updateFilters}
                />
                <select
                  id="selectFilterCategory"
                  data-aos="fade-in"
                  className="af-gallery-filter__location"
                  value={categoryOption}
                  onChange={updateFilters}
                >
                  <option value="">Todos las categorias</option>
                  <option value="Infantil">Infantil</option>
                  <option value="Junior">Junior</option>
                </select>
                <select
                  id="selectFilterCity"
                  data-aos="fade-in"
                  className="af-gallery-filter__location"
                  value={locationOption}
                  onChange={updateFilters}
                >
                  <option value="">Todos los municipios</option>
                  <option value="Apan">Apan</option>
                  <option value="Calera">Calera</option>
                </select>
              </section>
              <ul className="af-gallery">
                {
                  responseData.map((draw, index) => (
                    <li
                      key={index}
                      className="af-gallery__item"
                      data-aos="fade-down"
                    >
                      <CardDraw onClick={setCurrentDraw} data={draw} />
                    </li>
                  ))
                }
              </ul>
              <div className="af-pagination-drawings">
                {
                  responsePages.map((page, index) => (
                    <a key={index}
                      page={page}
                      className={`af-gallery__pagebtn ${page == 1 ? 'btnGalleryActiveAf' : ''}`}
                      data-aos="fade-down" onClick={e => dataDraws(page, maxDraws())}>{page}</a>
                  ))
                }
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <button
                className="af-gallery__getback"
                onClick={() => setCurrentDraw()}
              >
                Volver
              </button>
              <DrawPreview data={currentDraw} dataAos="fade-left" />
              <h2 className="af-gallery__subtitle" data-aos="fade-in">
                Otros dibujos
              </h2>
              <ul className="af-gallery">
                {responseData.slice(0, 3).map((draw, index) => (
                  <li
                    key={index}
                    className="af-gallery__item"
                    data-aos="fade-down"
                  >
                    <CardDraw onClick={handleClickDraw} data={draw} />
                  </li>
                ))}
              </ul>
            </React.Fragment>
          )}
        </div>
        <div className="btnSeeRanking">
          <a href="/ranking">Ver ranking</a>
        </div>
      </div>
    </main>
  );
};

export default Loader(Gallery);
